import { render, staticRenderFns } from "./PersonSearchForm.vue?vue&type=template&id=12ef9101&"
import script from "./PersonSearchForm.vue?vue&type=script&lang=js&"
export * from "./PersonSearchForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports